import { Box } from '@lego/klik-ui';
import { Navigate, useParams } from 'react-router-dom';
import { BreadCrumb, Loader } from '@/components/common';
import { DeviceCloningView } from '@/components/common/DeviceCloning';
import { useDocumentTitle } from '@/hooks/common';
import { useDevice } from '@/hooks/device';
import { paths } from '@/utility/global_paths';

const DeviceActionsClonePageContent = ({ deviceId }: { deviceId: number }) => {
  const { data: device, error, isLoading } = useDevice(deviceId);
  useDocumentTitle('Clone Device');

  if (isLoading || error || !device) {
    return (
      <Box>
        <Loader />
      </Box>
    );
  }

  return (
    <>
      <BreadCrumb
        crumbs={[
          { label: 'Workspaces', path: paths.workspaces },
          {
            label: `Workspace #${device.workspaceId}`,
            path: paths.workspaceById(device.workspaceId),
          },
          { label: `Device #${device.id}`, path: paths.deviceById(device.id) },
          { label: 'Clone From Source Device' },
        ]}
      />
      <DeviceCloningView targetDevice={device} />
    </>
  );
};

export const DeviceActionsClonePage = () => {
  const { deviceId } = useParams();
  if (!deviceId || !Number.parseInt(deviceId, 10)) {
    return <Navigate to={paths.devices} />;
  }

  return <DeviceActionsClonePageContent deviceId={Number.parseInt(deviceId, 10)} />;
};
